/**
 * Monta o prompt de imagem para slides que não têm `imagePrompt` próprio.
 *
 * Substitui o antigo `An abstract representation of: <50 chars>`, que pedia
 * abstração explicitamente e truncava no meio da palavra — as duas causas de
 * imagem genérica e desconexa do conteúdo.
 */

const MAX_CONTENT_CHARS = 240;

const FRAMING = 'A specific photographic scene with a human subject and clear emotional tone';
const CONSTRAINTS = 'No text, no interfaces, no charts.';

function stripMarkdown(text: string): string {
  return text
    .replace(/^#{1,6}\s+/gm, '')
    .replace(/\*\*(.+?)\*\*/g, '$1')
    .replace(/\*(.+?)\*/g, '$1')
    .replace(/`(.+?)`/g, '$1')
    .replace(/\s+/g, ' ')
    .trim();
}

function truncateAtWord(text: string, max: number): string {
  if (text.length <= max) return text;
  const cut = text.slice(0, max);
  const lastSpace = cut.lastIndexOf(' ');
  return (lastSpace > 0 ? cut.slice(0, lastSpace) : cut).trimEnd();
}

export function buildFallbackImagePrompt(content: string): string {
  const clean = truncateAtWord(stripMarkdown(content), MAX_CONTENT_CHARS);
  if (!clean) return `${FRAMING}. ${CONSTRAINTS}`;
  return `${FRAMING}, illustrating: "${clean}". ${CONSTRAINTS}`;
}
